(function () {
  const $$ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$$ = (sel, ctx = document) => ctx.querySelectorAll(sel);

  const forms = $$$('.pp-superform');
  if (!forms.length) return;

  function applyCorrectFrequency(form, btn, preserveExisting = false) {
    // If preserveExisting is true and there's already an active frequency, don't change it
    if (preserveExisting) {
      const existingActive = form.querySelector('.frequency-option button.active');
      if (existingActive) return;
    }
    
    const jars = parseInt(btn.dataset.jars, 10);
    const title = btn.querySelector('.price-title')?.textContent?.toLowerCase() || "";
    const handle = form.dataset.productHandle;

    const freqBtns = form.querySelectorAll('.frequency-option button');
    if (!freqBtns.length) return;

    let targetDays = "";

    const specialProducts = [
      "the-dream-body-stack",
      "ultimate-alpha-stack",
      "ultimate-alpha-stack-plus",
      "dream-body-stack-alpha-gut-reset",
      "ultimate-alpha-stack-plus-memorial-day-sale",
      "the-dream-body-stack™-memorial-day-sale",
      "ultimate-alpha-stack-memorial-day-sale",
      "ultimate-alpha-stack-plus-memorial-day-sale-campaign",
      "the-dream-body-stack™-memorial-day-sale-campaign",
      "ultimate-alpha-stack-memorial-day-sale-campaign",
      "retargeting-ultimate-alpha-stack"
    ];

    if (specialProducts.includes(handle)) {
      if (jars === 1) targetDays = "30";
      if (jars === 2) targetDays = "60";
      if (jars === 3) targetDays = "90";
    }
    else if (handle === "alpha-gut-reset") {
      if (jars === 1) targetDays = "30";
      if (jars === 2) targetDays = "60";
      if (jars === 4) targetDays = "90";
    }
    else if (title.includes("pack")) {
      if (jars === 1) targetDays = "30";
      if (jars === 2) targetDays = "90";
    }
    else if (title.includes("jar")) {
      if (jars === 1) targetDays = "30";
      if (jars === 2) targetDays = "60";
      if (jars === 3) targetDays = "90";
    }

    // Only update frequencies if we have a target
    if (targetDays) {
      freqBtns.forEach(b => {
        const days = b.dataset.frequencyDays || b.textContent.match(/(\d+)/)?.[0];
        b.classList.toggle("active", days === targetDays);
      });
    }
  }

  function updateJarsFromFrequency(form, freqBtn) {
    const freqText = freqBtn.textContent.trim();
    const daysMatch = freqBtn.dataset.frequencyDays || freqText.match(/(\d+)/)?.[0];
    if (!daysMatch) return;
    
    const days = parseInt(daysMatch, 10);
    const handle = form.dataset.productHandle;
    const activeJar = form.querySelector('.jars-option button.active');
    const title = activeJar?.querySelector('.price-title')?.textContent?.toLowerCase() || "";
    
    let targetJars = null;
    
    const specialProducts = [
      "the-dream-body-stack",
      "ultimate-alpha-stack",
      "ultimate-alpha-stack-plus",
      "dream-body-stack-alpha-gut-reset",
      "ultimate-alpha-stack-plus-memorial-day-sale",
      "the-dream-body-stack™-memorial-day-sale",
      "ultimate-alpha-stack-memorial-day-sale",
      "ultimate-alpha-stack-plus-memorial-day-sale-campaign",
      "the-dream-body-stack™-memorial-day-sale-campaign",
      "ultimate-alpha-stack-memorial-day-sale-campaign",
      "retargeting-ultimate-alpha-stack"
    ];
    
    if (specialProducts.includes(handle)) {
      if (days === 30) targetJars = 1;
      if (days === 60) targetJars = 2;
      if (days === 90) targetJars = 3;
    }
    else if (handle === "alpha-gut-reset") {
      if (days === 30) targetJars = 1;
      if (days === 60) targetJars = 2;
      if (days === 90) targetJars = 4;
    }
    else if (title.includes("pack")) {
      if (days === 30) targetJars = 1;
      if (days === 90) targetJars = 2;
    }
    else if (title.includes("jar")) {
      if (days === 30) targetJars = 1;
      if (days === 60) targetJars = 2;
      if (days === 90) targetJars = 3;
    }
    
    // Find and activate the matching jar button
    if (targetJars !== null) {
      const jarButtons = form.querySelectorAll('.jars-option button');
      
      jarButtons.forEach(btn => {
        const jarsMatch = btn.textContent.match(/(\d+)\s*(?:jar|bottle|pack)/i);
        const jarsData = parseInt(btn.dataset.jars, 10);
        
        if ((jarsMatch && parseInt(jarsMatch[1], 10) === targetJars) || jarsData === targetJars) {
          // Activate this jar button
          jarButtons.forEach(b => b.classList.remove('active'));
          btn.classList.add('active');
          
          // Update form with new jar selection
          updateForm(form);
        }
      });
    }
  }

  function initializeFrequencyPrices(form, isSub) {
    const jarButtons = form.querySelectorAll('.jars-option button');
    const freqBtns = form.querySelectorAll('.frequency-option button');
    const handle = form.dataset.productHandle;
    
    if (!freqBtns.length) return;
    
    // For each frequency button, find the corresponding jar button and get its price
    freqBtns.forEach(freqBtn => {
      const days = parseInt(freqBtn.dataset.frequencyDays, 10);
      if (!days) return;
      
      // Determine which jar matches this frequency
      let targetJars = 1;
      if (days === 30) targetJars = 1;
      if (days === 60) targetJars = 2;
      if (days === 90) targetJars = 3;
      
      // Adjust for special products
      if (handle === "alpha-gut-reset" && days === 90) targetJars = 4;
      
      // Find the matching jar button
      let matchingJar = null;
      jarButtons.forEach(jarBtn => {
        const jars = parseInt(jarBtn.dataset.jars, 10);
        if (jars === targetJars) {
          matchingJar = jarBtn;
        }
      });
      
      if (matchingJar) {
        let displayPrice = '';
        let comparePrice = '';
        
        if (isSub) {
          // Subscribe is active
          displayPrice = matchingJar.dataset.displaySubscribe;
          
          if (days === 30) {
            // For 30 days: use one-time price as compare at price
            comparePrice = matchingJar.dataset.displayOnetime;
          } else if (days === 90) {
            // For 90 days: use one-time price as compare at price
            comparePrice = matchingJar.dataset.displayOnetime;
          } else {
            // For 60 days: no compare at price
            comparePrice = '';
          }
        } else {
          // One-time is active - show one-time price only
          displayPrice = matchingJar.dataset.displayOnetime;
          comparePrice = '';
        }
        
        // Update frequency button prices
        const priceSpan = freqBtn.querySelector('.frequency-price-value');
        const compareSpan = freqBtn.querySelector('.frequency-price-compare');
        
        if (priceSpan && displayPrice) {
          priceSpan.textContent = displayPrice;
        }
        
        // Handle compare at price
        if (compareSpan && comparePrice && comparePrice !== '0' && comparePrice !== '' && isSub) {
          compareSpan.textContent = comparePrice;
          compareSpan.style.display = 'inline';
          compareSpan.style.textDecoration = 'line-through';
          compareSpan.style.marginRight = '6px';
          compareSpan.style.fontSize = '0.85em';
          compareSpan.style.opacity = '0.7';
          
          if (priceSpan) {
            priceSpan.style.color = '#ef4b5b';
            priceSpan.style.fontWeight = 'bold';
          }
        } else if (compareSpan) {
          compareSpan.style.display = 'none';
          if (priceSpan) {
            priceSpan.style.color = '';
            priceSpan.style.fontWeight = '';
          }
        }
        
        // Update per serving text
        const perServingSpan = freqBtn.querySelector('.frequency-per-serving');
        if (perServingSpan && displayPrice) {
          const parsePrice = (priceStr) => {
            if (!priceStr) return 0;
            return parseFloat(priceStr.replace(/[^0-9.-]/g, ''));
          };
          const totalPriceNum = parsePrice(displayPrice);
          
          let perServingPrice;
          
          // Check if this is an EstroControl product
          if (handle && (handle.includes('estrocontrol') || handle.includes('estro-control'))) {
            // EstroControl: Different divisor based on frequency days
            if (days === 30) {
              // 30-day supply: divide by 24
              perServingPrice = totalPriceNum / 24;
            } else if (days === 90) {
              // 90-day supply: divide by 72
              perServingPrice = totalPriceNum / 72;
            } else {
              // 60-day supply: default to jars × 30
              const servingsPerJar = 30;
              const totalServings = targetJars * servingsPerJar;
              perServingPrice = totalPriceNum / totalServings;
            }
          } else {
            // Other products: Use jars × 30 servings per jar
            const servingsPerJar = 30;
            const totalServings = targetJars * servingsPerJar;
            perServingPrice = totalPriceNum / totalServings;
          }
          
          perServingSpan.textContent = `$${perServingPrice.toFixed(2)} per serving`;
        }
      }
    });
  }

  function updateAllJarsPerJarPrice(form, isSub) {
    const allJarButtons = form.querySelectorAll('.jars-option button');
    
    allJarButtons.forEach(jarButton => {
      const priceValueSpan = jarButton.querySelector('.price-value');
      if (!priceValueSpan) return;
      
      const perJarPrice = isSub 
        ? jarButton.dataset.displayPerjarSub 
        : jarButton.dataset.displayPerjarOnetime;
      
      if (perJarPrice) {
        priceValueSpan.textContent = perJarPrice;
      }
    });
  }

  function updateSaveBadges(form) {
    const isSub = form.querySelector('.buying-option .active')?.dataset.option === 'subscribe';
    
    // Only show save badges when subscribe is active
    if (!isSub) {
      form.querySelectorAll('.save-badge').forEach(badge => {
        badge.style.display = 'none';
      });
      return;
    }
    
    const freqBtns = form.querySelectorAll('.frequency-option button');
    
    freqBtns.forEach(freqBtn => {
      const days = freqBtn.dataset.frequencyDays;
      if (!days) return;
      
      // Find the corresponding jar button for this frequency
      let targetJars = 1;
      if (days === '30') targetJars = 1;
      if (days === '60') targetJars = 2;
      if (days === '90') targetJars = 3;
      
      // Adjust for special products
      const handle = form.dataset.productHandle;
      if (handle === "alpha-gut-reset" && days === '90') targetJars = 4;
      
      // Find the matching jar button
      let matchingJar = null;
      const jarButtons = form.querySelectorAll('.jars-option button');
      jarButtons.forEach(jarBtn => {
        const jars = parseInt(jarBtn.dataset.jars, 10);
        if (jars === targetJars) {
          matchingJar = jarBtn;
        }
      });
      
      if (matchingJar) {
        // Get the subscribe price
        const subscribePrice = parseFloat(matchingJar.dataset.displaySubscribe?.replace(/[^0-9.-]/g, '') || 0);
        
        // Choose the correct compare price based on frequency days
        let comparePrice = 0;
        if (days === '30') {
          // For 30 days: use one-time price as compare
          comparePrice = parseFloat(matchingJar.dataset.displayOnetime?.replace(/[^0-9.-]/g, '') || 0);
        } else if (days === '90') {
          // For 90 days: use one-time price as compare
          comparePrice = parseFloat(matchingJar.dataset.displayOnetime?.replace(/[^0-9.-]/g, '') || 0);
        } else {
          // For 60 days: no compare
          comparePrice = 0;
        }
        
       // Calculate save percentage
        if (comparePrice > 0 && subscribePrice > 0 && comparePrice > subscribePrice) {
          const saveAmount = comparePrice - subscribePrice;
          const savePercentage = Math.round((saveAmount / comparePrice) * 100);
          
          const badge = freqBtn.querySelector('.save-badge');
          if (badge) {
            // Check if any ancestor (parent, grandparent, etc.) has class pp-superform-ss1
            const hasSuperFormClass = badge.closest('.pp-superform-ss1') !== null;
            
            if (hasSuperFormClass) {
              badge.textContent = `${savePercentage}% OFF`;
            } else {
              badge.textContent = `Save ${savePercentage}%`;
            }
            
            badge.style.display = 'inline-block';
            
            // Add different colors based on save percentage
            if (savePercentage >= 25) {
              badge.style.background = '#2c7a2c'; // Green for high savings
            } else if (savePercentage >= 15) {
              badge.style.background = '#f39c12'; // Orange for medium savings
            } else {
              badge.style.background = '#ef4b5b'; // Red for low savings
            }
          }
        } else {
          const badge = freqBtn.querySelector('.save-badge');
          if (badge) {
            badge.style.display = 'none';
          }
        }
      }
    });
  }

  forms.forEach(form => {
    if (form.dataset.superformExternalInit === "true") return;
    form.dataset.superformExternalInit = "true";

    form.addEventListener('click', e => {
      const btn = e.target.closest('button');
      if (!btn) return;

      // Buying option
      if (btn.closest('.buying-option')) {
        const wasSub = form.querySelector('.buying-option .active')?.dataset.option === 'subscribe';
        const isSub = btn.dataset.option === 'subscribe';
        
        activate(btn);
        
        // Update ALL jar buttons' per-bottle prices
        updateAllJarsPerJarPrice(form, isSub);
        
        // Update frequency prices based on new buying option
        initializeFrequencyPrices(form, isSub);
        
        // Update frequency for active jar if subscribe
        const activeJar = form.querySelector('.jars-option button.active');
        if (isSub && activeJar) {
          const shouldPreserve = wasSub;
          if (!shouldPreserve) {
            const freqBtns = form.querySelectorAll('.frequency-option button');
            const hasActive = Array.from(freqBtns).some(b => b.classList.contains('active'));
            if (!hasActive && freqBtns.length) {
              // Default to second button (60 days / 2 jars) when first switching to subscribe
              if (freqBtns[1]) {
                freqBtns[1].classList.add('active');
              } else {
                freqBtns[0].classList.add('active');
              }
            }
          } else {
            applyCorrectFrequency(form, activeJar, true);
          }
        }
        
        // Update all other prices
        updateForm(form);
        
        // Update save badges
        updateSaveBadges(form);
      }

      // Jars
      if (btn.closest('.jars-option')) {
        activate(btn);
        updateForm(form);

        const isSub = form.querySelector('.buying-option .active')?.dataset.option === 'subscribe';
        
        // Update frequency selection based on jars (Jars → Frequency)
        if (isSub) {
          applyCorrectFrequency(form, btn, false);
        }
        
        // Update save badges
        updateSaveBadges(form);
      }

      // Frequency - Update jars based on frequency selection
      if (btn.closest('.frequency-option')) {
        activate(btn);
        
        // Update jars based on frequency selection (Frequency → Jars)
        const isSub = form.querySelector('.buying-option .active')?.dataset.option === 'subscribe';
        if (isSub) {
          updateJarsFromFrequency(form, btn);
        }
        
        updateForm(form);
        
        // Update save badges
        updateSaveBadges(form);
      }

      // Add to cart
      if (btn.classList.contains('add-to-cart')) {
        e.preventDefault();
        addToCart(form, btn);
      }
    });

    // Initialize - set all jar prices based on initial buying option
    const initialIsSub = form.querySelector('.buying-option .active')?.dataset.option === 'subscribe';
    updateAllJarsPerJarPrice(form, initialIsSub);
    
    // Initialize frequency prices
    initializeFrequencyPrices(form, initialIsSub);
    
    updateForm(form);
    
    // Initialize save badges
    updateSaveBadges(form);
    
    // Initialize frequency selection if subscribe is active by default
    if (initialIsSub) {
      const freqBtns = form.querySelectorAll('.frequency-option button');
      const hasActive = Array.from(freqBtns).some(b => b.classList.contains('active'));
      if (!hasActive && freqBtns.length) {
        // Set second button (60 days / 2 jars) as active on initialization
        if (freqBtns[1]) {
          freqBtns[1].classList.add('active');
        } else {
          freqBtns[0].classList.add('active');
        }
      }
    }
  });

  function activate(btn) {
    const parent = btn.parentElement;
    parent.querySelectorAll('.active').forEach(a => a.classList.remove('active'));
    btn.classList.add('active');
  }

  function updateForm(form) {
    const buyActive = $$('.buying-option .active', form);
    const jarActive = $$('.jars-option .active', form);
    
    // Store current frequency active button BEFORE any changes
    const currentFreqActive = $$('.frequency-option .active', form);
    const currentFreqSellingPlanId = currentFreqActive ? currentFreqActive.dataset.sellingPlanId : null;
    const hadActiveFreq = currentFreqActive !== null;

    if (!buyActive || !jarActive) return;

    const isSub = buyActive.dataset.option === 'subscribe';

    const oneTimeBtn = form.querySelector('.buying-option [data-option="one-time"]');
    const subBtn = form.querySelector('.buying-option [data-option="subscribe"]');

    function updatePriceWrapper(btn, displayPrice, comparePrice) {
      if (!btn) return;

      let wrapper = btn.querySelector('.NewRadioOption__Price');
      if (!wrapper) {
        wrapper = document.createElement('span');
        wrapper.className = 'NewRadioOption__Price';
        btn.appendChild(wrapper);
      }

      wrapper.innerHTML = '';

      if (comparePrice && comparePrice !== '0' && comparePrice !== '') {
        const compareEl = document.createElement('span');
        compareEl.className = 'NewRadioOption__Price_Compare';
        compareEl.style.textDecoration = 'line-through';
        compareEl.style.fontWeight = '400';
        compareEl.style.marginRight = '6px';
        compareEl.textContent = comparePrice;
        wrapper.appendChild(compareEl);
      }

      const normalEl = document.createElement('span');
      normalEl.className = 'NewRadioOption__Price_Normal';
      normalEl.textContent = displayPrice || '';
      wrapper.appendChild(normalEl);
      if (comparePrice && comparePrice !== '0' && comparePrice !== '') {
        normalEl.style.color = '#ef4b5b';
      }
    }

    // For buying options: if subscribe is active, show subscribe price with one-time as compare
    if (isSub) {
      updatePriceWrapper(
        oneTimeBtn,
        jarActive.dataset.displayOnetime,
        '' // One-time button shows its regular price with no compare
      );
      updatePriceWrapper(
        subBtn,
        jarActive.dataset.displaySubscribe,
        jarActive.dataset.displayOnetime // Subscribe shows one-time price as compare
      );
    } else {
      updatePriceWrapper(
        oneTimeBtn,
        jarActive.dataset.displayOnetime,
        ''
      );
      updatePriceWrapper(
        subBtn,
        jarActive.dataset.displaySubscribe,
        ''
      );
    }

    const freqBox = $$('.frequency-option', form);
    const freqHead = $$('.delivery-heading', form);
    if (freqBox) freqBox.style.display = isSub ? 'flex' : 'none';
    if (freqHead) freqHead.style.display = isSub ? 'block' : 'none';
    
    // Restore frequency active state if we're in subscribe mode and had one before
    if (isSub && hadActiveFreq && currentFreqSellingPlanId) {
      const freqBtn = form.querySelector(`.frequency-option button[data-selling-plan-id="${currentFreqSellingPlanId}"]`);
      if (freqBtn && !freqBtn.classList.contains('active')) {
        form.querySelectorAll('.frequency-option button').forEach(b => b.classList.remove('active'));
        freqBtn.classList.add('active');
      }
    } else if (isSub && !hadActiveFreq) {
      const freqBtns = form.querySelectorAll('.frequency-option button');
      const hasActive = Array.from(freqBtns).some(b => b.classList.contains('active'));
      if (!hasActive && freqBtns.length) {
        // Set second button (60 days / 2 jars) as active
        if (freqBtns[1]) {
          freqBtns[1].classList.add('active');
        } else {
          freqBtns[0].classList.add('active');
        }
      }
    }

    // Get the active frequency days to determine correct compare price for add-to-cart button
    const activeFreq = $$('.frequency-option .active', form);
    const activeDays = activeFreq ? activeFreq.dataset.frequencyDays : null;

    const addToCartBtn = form.querySelector('.add-to-cart');
    if (addToCartBtn) {
      let currentPrice = isSub 
        ? jarActive.dataset.displaySubscribe 
        : jarActive.dataset.displayOnetime;
      
      let currentComparePrice = '';
      
      if (isSub) {
        // Choose compare price based on active frequency days
        if (activeDays === '30') {
          // For 30 days: use one-time price as compare
          currentComparePrice = jarActive.dataset.displayOnetime;
        } else if (activeDays === '90') {
          // For 90 days: use one-time price as compare
          currentComparePrice = jarActive.dataset.displayOnetime;
        } else {
          // For 60 days: no compare price
          currentComparePrice = '';
        }
      }
      
      const existingPriceWrapper = addToCartBtn.querySelector('.cart-btn-price');
      if (existingPriceWrapper) existingPriceWrapper.remove();
      
      const anyPriceSpans = addToCartBtn.querySelectorAll('.cart-btn-compare, .cart-btn-price-current');
      anyPriceSpans.forEach(span => span.remove());
      
      const priceWrapper = document.createElement('span');
      priceWrapper.className = 'cart-btn-price';
      
      if (currentComparePrice && currentComparePrice !== '0' && currentComparePrice !== '' && isSub) {
        const compareSpan = document.createElement('span');
        compareSpan.className = 'cart-btn-compare';
        compareSpan.style.textDecoration = 'line-through';
        compareSpan.style.marginRight = '8px';
        compareSpan.style.fontSize = '0.85em';
        compareSpan.style.opacity = '0.7';
        compareSpan.textContent = currentComparePrice;
        priceWrapper.appendChild(compareSpan);
      }
      
      const priceSpan = document.createElement('span');
      priceSpan.className = 'cart-btn-price-current';
      priceSpan.style.fontWeight = 'bold';
      priceSpan.textContent = currentPrice || '';
      priceWrapper.appendChild(priceSpan);
      
      let buttonTextSpan = addToCartBtn.querySelector('.cart-btn-text');
      const originalButtonText = "Add to Cart";
      
      if (!buttonTextSpan) {
        const existingText = addToCartBtn.childNodes[0]?.nodeType === Node.TEXT_NODE 
          ? addToCartBtn.childNodes[0].textContent.trim() 
          : "Add to Cart";
        
        buttonTextSpan = document.createElement('span');
        buttonTextSpan.className = 'cart-btn-text';
        buttonTextSpan.textContent = existingText || originalButtonText;
        
        Array.from(addToCartBtn.childNodes).forEach(node => {
          if (node.nodeType === Node.TEXT_NODE) node.remove();
        });
        
        addToCartBtn.insertBefore(buttonTextSpan, addToCartBtn.firstChild);
      }
      
      addToCartBtn.appendChild(priceWrapper);
      addToCartBtn.style.display = 'inline-flex';
      addToCartBtn.style.alignItems = 'center';
      addToCartBtn.style.gap = '8px';
      addToCartBtn.style.justifyContent = 'center';
    }

    const paymentTermsElement = form.querySelector('shopify-payment-terms');
    if (paymentTermsElement) {
      const variantId = jarActive.dataset.variantId;
      if (variantId && paymentTermsElement.getAttribute('variant-id') !== variantId) {
        paymentTermsElement.setAttribute('variant-id', variantId);
      }
    }
  }

  function addToCart(form, btn) {
    const jarActive = $$('.jars-option .active', form);
    const buyActive = $$('.buying-option .active', form);
    const freqActive = $$('.frequency-option .active', form);
    if (!jarActive || !buyActive) return;

    const variantId = jarActive.dataset.variantId;
    const isSub = buyActive.dataset.option === 'subscribe';
    const sellingPlanId = isSub && freqActive ? freqActive.dataset.sellingPlanId : null;

    const data = {
      id: variantId,
      quantity: 1
    };
    if (sellingPlanId) data.selling_plan = sellingPlanId;

    const textSpan = btn.querySelector('.cart-btn-text');
    const originalText = textSpan ? textSpan.textContent : 'Add to Cart';
    
    btn.disabled = true;
    
    if (textSpan) {
      textSpan.textContent = 'Adding…';
    } else {
      btn.textContent = 'Adding…';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    })
      .then(r => r.json())
      .then(resp => {
        if (resp.status === 422) {
          console.error(resp.message);
          if (textSpan) {
            textSpan.textContent = originalText;
          } else {
            btn.textContent = originalText;
          }
          btn.disabled = false;
          return;
        }

        if (typeof CartDrawer !== 'undefined') {
          if (CartDrawer.update) CartDrawer.update();
          if (CartDrawer.setPreEmpty) CartDrawer.setPreEmpty(false);
          if (CartDrawer.removeAttribute) CartDrawer.removeAttribute('is-empty');
          if (CartDrawer.open) CartDrawer.open();
        } else {
          document.dispatchEvent(new CustomEvent('cart:open'));
        }

        if (textSpan) {
          textSpan.textContent = 'Added!';
          setTimeout(() => {
            textSpan.textContent = originalText;
            btn.disabled = false;
          }, 1200);
        } else {
          btn.textContent = 'Added!';
          setTimeout(() => {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1200);
        }
      })
      .catch(err => {
        console.error('Error adding to cart', err);
        if (textSpan) {
          textSpan.textContent = originalText;
        } else {
          btn.textContent = originalText;
        }
        btn.disabled = false;
      });
  }

  console.log('%c✓ BeyondAlpha superform JS active - EstroControl: 30-day uses /24, 90-day uses /72', 'color:#3db13d');
})();